import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as dynamicEcs from '../../../../../dynamic-ecs'
import type * as currentRendering from '../../../feature'
import type { Feature } from '../feature'

/**
 * Triggers the disposal of all Entity Collection instances
 * when a page render request is made.
 */
export const triggerEcDisposeOnPageRenderRequest = store.effects.create(
  (
    feature: Feature,
    currentRendering: currentRendering.Feature,
    dynamicEcsFeature: dynamicEcs.Feature,
  ) =>
    currentRendering.actions.render.request.observe().pipe(
      rxjs.map(() =>
        dynamicEcsFeature.actions.dispose
          .from('triggerEcDisposeOnPageRenderRequest (effect)')
          // Dispose all dynamic ECS instances
          .create({ all: true }),
      ),
    ),
)
